<script setup>
import { ref } from 'vue'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/popover'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import GbButton from '@/components/GbButton.vue'


const tooltipContentWithIcon = ref(`
<div class="flex align-middle gap-2"><span class="material-icons-outlined text-lg">public</span> Hello world</div>
    `)
const tooltipContentShort = ref(`Print`)
const tooltipContentLong = ref(
  `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`
)
const tooltipTwoLines = ref(`<p>Hello</p><p>Two Lines</p>`)
const onSubmit = () => {
  console.log('Form submitted')
}
</script>
<template>
  <button
    type="button"
    aria-label="Hello world"
    class="mb-2 block rounded-md bg-blue-400 px-4 py-2 text-white"
    v-tooltip.right="{ value: tooltipContentWithIcon, escape: false }"
  >
    tooltip right
  </button>
  <button
    type="button"
    aria-label="Hello world"
    class="mb-2 block rounded-md bg-blue-400 px-4 py-2 text-white"
    v-tooltip.left="{ value: tooltipContentShort, escape: false }"
  >
    tooltip left
  </button>
  <button
    type="button"
    aria-label="Hello world"
    class="mb-2 block rounded-md bg-blue-400 px-4 py-2 text-white"
    v-tooltip.top="{ value: tooltipTwoLines, escape: false }"
  >
    tooltip top
  </button>
  <button
    type="button"
    aria-label="Hello world"
    class="mb-2 block rounded-md bg-blue-400 px-4 py-2 text-white"
    v-tooltip.bottom="{ value: tooltipContentLong, escape: false }"
  >
    tooltip bottom
  </button>

  <section class="mb-4">
    <h2 class="text-2xl font-semibold mb-4">ShadCn Popover (unstyled)</h2>
    <div class="flex flex-wrap gap-4">
      <Popover>
        <PopoverTrigger as-child>
          <GbButton size="small">Open Popover</GbButton>
        </PopoverTrigger>
        <PopoverContent class="w-80">
          <div class="grid gap-4">
            <div class="space-y-2">
              <h4 class="font-medium leading-none">Dimensions</h4>
              <p class="text-sm text-muted-foreground">
                Set the dimensions for the layer.
              </p>
            </div>
            <div class="grid gap-2">
              <div class="grid grid-cols-3 items-center gap-4">
                <label htmlFor="width">Width</label>
                <input
                  id="width"
                  defaultValue="100%"
                  class="col-span-2 h-8"
                />
              </div>
              <div class="grid grid-cols-3 items-center gap-4">
                <label htmlFor="height">Height</label>
                <input
                  id="height"
                  defaultValue="25px"
                  class="col-span-2 h-8"
                />
              </div>
            </div>
          </div>
        </PopoverContent>
      </Popover>

      <Popover>
        <PopoverTrigger as-child>
          <GbButton size="small">With Form</GbButton>
        </PopoverTrigger>
        <PopoverContent class="w-80">
          <form @submit.prevent="onSubmit">
            <div class="grid gap-4">
              <div class="space-y-2">
                <h4 class="font-medium leading-none">Settings</h4>
                <p class="text-sm text-muted-foreground">
                  Configure your preferences.
                </p>
              </div>
              <div class="grid gap-2">
                <label htmlFor="name">Name</label>
                <input
                  id="name"
                  placeholder="Enter your name"
                  class="h-8"
                />
                <GbButton type="submit" class="w-full">Save Changes</GbButton>
              </div>
            </div>
          </form>
        </PopoverContent>
      </Popover>
    </div>
  </section>

  <section class="mb-12">
    <h2 class="text-2xl font-semibold mb-4">ShadCn Tooltip</h2>
    <div class="flex flex-wrap gap-4">
      <TooltipProvider>
        <Tooltip :delay-duration="0">
          <TooltipTrigger as-child>
            <GbButton size="small">Hover Me</GbButton>
          </TooltipTrigger>
          <TooltipContent>
            <p>Add to library</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger as-child>
            <GbButton size="small" :icon-only="true">
              <span class="sr-only">Add to favorites</span>
              <span class="material-icons-outlined">star</span>
            </GbButton>
          </TooltipTrigger>
          <TooltipContent>
            <p>Add to favorites</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      <TooltipProvider>
        <Tooltip :delay-duration="500">
          <TooltipTrigger as-child>
            <GbButton size="small">Delayed Tooltip</GbButton>
          </TooltipTrigger>
          <TooltipContent>
            <p>Appears after 500ms</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  </section>
</template>
